import { render, staticRenderFns } from "./container_depot_reside.vue?vue&type=template&id=3a1b0e48&scoped=true&"
import script from "./container_depot_reside.vue?vue&type=script&lang=js&"
export * from "./container_depot_reside.vue?vue&type=script&lang=js&"
import style0 from "./container_depot_reside.vue?vue&type=style&index=0&id=3a1b0e48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b0e48",
  null
  
)

export default component.exports